<div
  class="exposed-element">
  <div
    #portalTop
    class="exposed-element__overlay exposed-element__top"
  ></div>
  <div
    #portalLeft
    class="exposed-element__overlay exposed-element__left"
  ></div>
  <div
    #portalRight
    class="exposed-element__overlay exposed-element__right"
  ></div>
  <div
    #portalBottom
    class="exposed-element__overlay exposed-element__bottom"
  ></div>
  <div
    #portal
    data-cy="guided-tour.exposed-element-contents"
    class="exposed-element__contents"
    (click)="onExposedElementClick()"
    [ngClass]="{'exposed-element__contents--no-events': stepExposedElement.preventDefault}"
  ></div>
</div>
